export default {
    label_task:{
        en:"Varieties Incentive",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Incentive",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Incentive",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Varieties Incentive",
        bn:'ব্যবহারকারীর বিবরণ'
    },

}